import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      roleId: '',
      userId: '',
      userFullName: '',
      searchFromDate: '',
      searchToDate: '',
      vehicleTypeBaseOnTime: 'ambulance',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchModal: false,
      userAllRoles: [],
      dashboardIMG: require('@/assets/images/dashboard800Image.png'),
      //row 1
      //part 1
      allWorkingTime: '',
      missionsCount: '',
      loginLogoutTableHeader: [
        { text: 'تاریخ ورود', value: 'loginDate', align: 'start' },
        { text: 'تاریخ خروج', value: 'logoutDate', align: 'start' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
      ],
      loginLogoutTableItems: [],
      //part 2
      userLogin: '',
      userWorkStation: '',
      //pie Geographical
      pieGeographicalChartOption: {
        colors: [
          '#FF7600',
          '#007D83',
          '#002E91',
          '#D69415',
          '#C66512',
          '#0CC881',
          '#4986FF',
          '#FFB528',
          '#FF6925',
          '#02F4FF',
          '#1A63FF',
          '#FFA900',
        ],
        chart: {
          renderTo: 'dashboardQCPieCallChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      outOfServiceRequest: '',
      outOfServiceDurationAverage: '',
      //row 2
      deliveryTillMoveAverage: {
        ambulance: '',
        motorlance: '',
      },
      deliveryTillMoveFenceAverage: {
        ambulance: '',
        motorlance: '',
      },
      moveTillArriveFenceAverage: {
        ambulance: '',
        motorlance: '',
      },
      moveTillArriveAverage: {
        ambulance: '',
        motorlance: '',
      },
      patientWaitingDurationAverage: {
        ambulance: '',
        motorlance: '',
      },
      patientWaitingDurationFenceAverage: {
        ambulance: '',
        motorlance: '',
      },
      hospitalWaitingDurationAverage: {
        ambulance: '',
        motorlance: '',
      },
      hospitalWaitingDurationFenceAverage: {
        ambulance: '',
        motorlance: '',
      },
      //row 3
      ColumnResultChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        xAxis: {
          categories: [],
          useHTML: true,
          reversed: false,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
          stackLabels: {
            style: {
              backgroundColor: 'rgba(252, 255, 197, 0.7)',
              color: 'black',
              borderWidth: 1,
              wordWrap: 'break-word',
            },
            enabled: true,
            useHTML: true,
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          backgroundColor: '#eee',
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{series.name}</span>: <span  style="color:white">{point.y}</span></div>',
        },
        plotOptions: {
          useHTML: true,
          series: {
            borderWidth: 0,
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{series.name}: {point.y}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '9px',
                wordWrap: 'break-word',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [],
      },
    };
  },
  methods: {
    readyDashboard: function (data) {
      //row 1
      //part 1
      this.missionsCount = data.missionsCount ? data.missionsCount.valueLong : '-';
      let duration1 = Math.floor(data.workingHours.valueDouble);
      this.allWorkingTime = this.convertSecondsToHHMMss(duration1);

      //part 2
      this.userLogin = data.userLogin ? data.userLogin.valueLong : '-';
      this.userWorkStation = data.userWorkStation ? data.userWorkStation.valueLong : '-';
      //pie Geographical
      let pieChartData2 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray2 = JSON.parse(JSON.stringify([]));
      pieChartTempArray2 = JSON.parse(JSON.stringify(data.missionByGeographicalType));
      for (let i = 0; i < pieChartTempArray2.length; i++) {
        pieChartData2.push({
          name: pieChartTempArray2[i].title,
          y: pieChartTempArray2[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData2 = JSON.parse(JSON.stringify(pieChartData2));
      this.pieGeographicalChartOption.series[0].data = [];
      this.pieGeographicalChartOption.series[0].data = pieChartData2;
      //end pie Geographical
      this.outOfServiceRequest = data.outOfServiceRequest
        ? data.outOfServiceRequest.valueLong
        : '-';
      let duration = Math.floor(data.outOfServiceDurationAverage.valueDouble);

      this.outOfServiceDurationAverage = this.convertSecondsToHHMMss(duration);
      //row2
      // set time to motorlance and ambulance
      const ambulanceDeliveryTillMoveAverage = Math.floor(data.deliveryTillMoveAverage.valueDouble);
      this.deliveryTillMoveAverage.ambulance = this.convertSecondsToHHMMss(
        ambulanceDeliveryTillMoveAverage,
      );
      const motorlanceDeliveryTillMoveAverage = Math.floor(
        data.deliveryTillMoveAverageMotor.valueDouble,
      );
      this.deliveryTillMoveAverage.motorlance = this.convertSecondsToHHMMss(
        motorlanceDeliveryTillMoveAverage,
      );
      const ambulanceDeliveryTillMoveFenceAverage = Math.floor(
        data.deliveryTillMoveFenceAverage.valueDouble,
      );
      this.deliveryTillMoveFenceAverage.ambulance = this.convertSecondsToHHMMss(
        ambulanceDeliveryTillMoveFenceAverage,
      );
      const motorlanceDeliveryTillMoveFenceAverage = Math.floor(
        data.deliveryTillMoveFenceAverageMotor.valueDouble,
      );
      this.deliveryTillMoveFenceAverage.motorlance = this.convertSecondsToHHMMss(
        motorlanceDeliveryTillMoveFenceAverage,
      );
      const ambulanceMoveTillArriveAverage = Math.floor(data.moveTillArriveAverage.valueDouble);

      this.moveTillArriveAverage.ambulance = this.convertSecondsToHHMMss(
        ambulanceMoveTillArriveAverage,
      );
      const motorlanceMoveTillArriveAverage = Math.floor(
        data.moveTillArriveAverageMotor.valueDouble,
      );
      this.moveTillArriveAverage.motorlance = this.convertSecondsToHHMMss(
        motorlanceMoveTillArriveAverage,
      );
      const ambulanceMoveTillArriveFenceAverage = Math.floor(
        data.moveTillArriveFenceAverage.valueDouble,
      );
      this.moveTillArriveFenceAverage.ambulance = this.convertSecondsToHHMMss(
        ambulanceMoveTillArriveFenceAverage,
      );
      const motorlanceMoveTillArriveFenceAverage = Math.floor(
        data.moveTillArriveFenceAverageMotor.valueDouble,
      );
      this.moveTillArriveFenceAverage.motorlance = this.convertSecondsToHHMMss(
        motorlanceMoveTillArriveFenceAverage,
      );
      const ambulancePatientWaitingDurationAverage = Math.floor(
        data.patientWaitingDurationAverage.valueDouble,
      );
      this.patientWaitingDurationAverage.ambulance = this.convertSecondsToHHMMss(
        ambulancePatientWaitingDurationAverage,
      );
      const motorlancePatientWaitingDurationAverage = Math.floor(
        data.patientWaitingDurationAverageMotor.valueDouble,
      );
      this.patientWaitingDurationAverage.motorlance = this.convertSecondsToHHMMss(
        motorlancePatientWaitingDurationAverage,
      );
      const ambulancePatientWaitingDurationFenceAverage = Math.floor(
        data.patientWaitingDurationFenceAverage.valueDouble,
      );
      this.patientWaitingDurationFenceAverage.ambulance = this.convertSecondsToHHMMss(
        ambulancePatientWaitingDurationFenceAverage,
      );
      const motorlancePatientWaitingDurationFenceAverage = Math.floor(
        data.patientWaitingDurationFenceAverageMotor.valueDouble,
      );
      this.patientWaitingDurationFenceAverage.motorlance = this.convertSecondsToHHMMss(
        motorlancePatientWaitingDurationFenceAverage,
      );
      const ambulanceHospitalWaitingDurationAverage = Math.floor(
        data.hospitalWaitingDurationAverage.valueDouble,
      );
      this.hospitalWaitingDurationAverage.ambulance = this.convertSecondsToHHMMss(
        ambulanceHospitalWaitingDurationAverage,
      );
      const motorlanceHospitalWaitingDurationAverage = Math.floor(
        data.hospitalWaitingDurationAverageMotor.valueDouble,
      );
      this.hospitalWaitingDurationAverage.motorlance = this.convertSecondsToHHMMss(
        motorlanceHospitalWaitingDurationAverage,
      );

      const ambulanceHospitalWaitingDurationFenceAverage = Math.floor(
        data.hospitalWaitingDurationFenceAverage.valueDouble,
      );
      this.hospitalWaitingDurationFenceAverage.ambulance = this.convertSecondsToHHMMss(
        ambulanceHospitalWaitingDurationFenceAverage,
      );
      const motorlanceHospitalWaitingDurationFenceAverage = Math.floor(
        data.hospitalWaitingDurationFenceAverageMotor.valueDouble,
      );
      this.hospitalWaitingDurationFenceAverage.motorlance = this.convertSecondsToHHMMss(
        motorlanceHospitalWaitingDurationFenceAverage,
      );
      //row 3 cloumn
      if (data.missionResultByGeographicalType.length > 0) {
        let columnData = [];
        for (let i = 0; i < data.missionResultByGeographicalType.length; i++) {
          this.ColumnResultChartOptions.xAxis.categories.push(
            data.missionResultByGeographicalType[i].title,
          );
        }
        for (let j = 0; j < data.missionResultByGeographicalType[0].subItems.length; j++) {
          columnData.push({
            name: data.missionResultByGeographicalType[0].subItems[j].title,
            data: [],
          });
        }
        for (let i = 0; i < columnData.length; i++) {
          for (let j = 0; j < data.missionResultByGeographicalType.length; j++) {
            for (let z = 0; z < data.missionResultByGeographicalType[j].subItems.length; z++) {
              if (columnData[i].name == data.missionResultByGeographicalType[j].subItems[z].title) {
                if (data.missionResultByGeographicalType[j].subItems[z].valueLong > 0) {
                  columnData[i].data.push(
                    data.missionResultByGeographicalType[j].subItems[z].valueLong,
                  );
                } else {
                  columnData[i].data.push(null);
                }
              }
            }
          }
        }
        this.ColumnResultChartOptions.series = columnData;
      }
    },
    readyLoginLogoutData: function (data) {
      this.loginLogoutTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '-';
        let logoutDate = '-';
        let duration = Math.floor(data[i].duration);

        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.loginLogoutTableItems.push({
          loginDate: loginDate,
          logoutDate: logoutDate,
          duration: this.convertSecondsToHHMMss(duration),
        });
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    backToReport: function () {
      this.$router.push({ name: 'qcUsersForQCReport' });
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.getUserRoleList();
      this.searchModal = true;
    },
    search: function () {
      this.searchModal = false;
      this.getQCUsersLoginLogoutReportFunction(this.searchFromDate, this.searchToDate, this.userId);
      this.getQCUserTechnicianDashboardFunction(this.searchFromDate, this.searchToDate, this.userId);
      // this.getQCUsersLoginLogoutReportFunction(
      //   this.searchFromDate,
      //   this.searchToDate,
      //   this.userId
      // );
    },
    cancelSearch: function () {
      this.searchModal = false;
    },
    showAllLoginLogout: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      this.$router.push({ name: 'user115AllLoginLogout', params: { id: id } });
    },
  },
};
